import(/* webpackMode: "eager", webpackExports: ["NavLinkClient"] */ "/vercel/path0/app/(dashboard)/nav-link-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(dashboard)/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchInput"] */ "/vercel/path0/app/(dashboard)/search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuContent","DropdownMenuItem","DropdownMenuSeparator"] */ "/vercel/path0/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.25.2_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
